import { render, staticRenderFns } from "./SupplierOffers.vue?vue&type=template&id=d1f0a79a"
import script from "./SupplierOffers.vue?vue&type=script&lang=js"
export * from "./SupplierOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports